module.exports = __webpack_public_path__ + "static/media/Rover.4a61fc97.jpeg";